/* angular:styles/component:css;e4035a7f4add7b90f512894ef08c58836e57d2d66d74df2664c66bcb8f46bf3e;C:\fonte\MktplaceView\src\app\builder-screen-beta\inspector\inspector-dependencies\inspector-dependencies.component.ts */
.deps-container {
  grid-column: 1 / -1;
  margin-top: 4px;
}
.deps-buttons {
  display: flex;
  gap: 6px;
}
.deps-buttons button {
  flex: 1;
}
.deps-help {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #8c8c8c;
  line-height: 1.3;
}
/*# sourceMappingURL=inspector-dependencies.component.css.map */
